// React Imports
import type { SVGAttributes } from 'react';
import React from 'react';

export const NotificationGold = (_props: SVGAttributes<SVGElement>) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M19.2823 14.8912V10.7139C19.2823 6.81747 16.123 3.6582 12.2266 3.6582H11.779C7.8826 3.6582 4.72333 6.81747 4.72333 10.7139V14.8912L4.03882 16.5235C3.5737 17.6292 4.38985 18.849 5.59213 18.849H18.4047C19.607 18.849 20.4232 17.6292 19.958 16.5235L19.2735 14.8912H19.2823Z"
        stroke="url(#paint0_linear_4207_106782)"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.0078 2V3.6674"
        stroke="url(#paint1_linear_4207_106782)"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.21875 18.8574H14.8001V19.2085C14.8001 20.7442 13.554 21.9991 12.0094 21.9991C10.4737 21.9991 9.21875 20.753 9.21875 19.2085V18.8574Z"
        stroke="url(#paint2_linear_4207_106782)"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear_4207_106782"
          x1="11.9984"
          y1="3.6582"
          x2="11.9984"
          y2="18.849"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFBE66" />
          <stop offset="0.34" stopColor="#EDB05D" />
          <stop offset="1" stopColor="#CA7701" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_4207_106782"
          x1="12.5078"
          y1="2"
          x2="12.5078"
          y2="3.6674"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFBE66" />
          <stop offset="0.34" stopColor="#EDB05D" />
          <stop offset="1" stopColor="#CA7701" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_4207_106782"
          x1="12.0094"
          y1="18.8574"
          x2="12.0094"
          y2="21.9991"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFBE66" />
          <stop offset="0.34" stopColor="#EDB05D" />
          <stop offset="1" stopColor="#CA7701" />
        </linearGradient>
      </defs>
    </svg>
  );
};
